import { compose } from 'redux';
import withBrowserInfo from '../../containers/redux/withBrowserInfo';
import withInventoryItemRecommendations from '../../containers/apollo/withInventoryItemRecommendations';
import ProductRecommendations from './ProductRecommendations';
import { withStrikethroughFeatureFlag } from '../../hooks/useStrikethroughFeatureFlag';

export default compose(
  withStrikethroughFeatureFlag,
  withBrowserInfo,
  withInventoryItemRecommendations
)(ProductRecommendations);
